// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 89 ? "component---src-templates-page-js" : chunkId) + "-" + {"60":"1e40c6f085d987caa1f6","89":"0a04fa9d0b4b6f024ef5","836":"93f689a80d52cde65f6a"}[chunkId] + ".js";
};